import { render, staticRenderFns } from "./total_issues_analytics_chart.vue?vue&type=template&id=4d700e88"
import script from "./total_issues_analytics_chart.vue?vue&type=script&lang=js"
export * from "./total_issues_analytics_chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports